import { FC } from 'react';
import './specimenListItemSkeleton.scss';

const SpecimenListItemSkeleton: FC = (): JSX.Element => {
  return (
    <article className="specimen-list-item-skeleton" aria-label="Loading specimen list item">
      <div className="specimen-list-item-skeleton__image skeleton-shimmer" />
      <div className="specimen-list-item-skeleton__content">
        <div className="specimen-list-item-skeleton__name skeleton-shimmer" />
        <div className="specimen-list-item-skeleton__details">
          <div className="specimen-list-item-skeleton__detail skeleton-shimmer" />
          <div className="specimen-list-item-skeleton__detail skeleton-shimmer" />
          <div className="specimen-list-item-skeleton__detail skeleton-shimmer" />
          <div className="specimen-list-item-skeleton__detail skeleton-shimmer" />
        </div>
        <div className="specimen-list-item-skeleton__breeder skeleton-shimmer" />
        <div className="specimen-list-item-skeleton__footer">
          <div className="specimen-list-item-skeleton__price skeleton-shimmer" />
          <div className="specimen-list-item-skeleton__actions">
            <div className="specimen-list-item-skeleton__button skeleton-shimmer" />
            <div className="specimen-list-item-skeleton__button skeleton-shimmer" />
          </div>
        </div>
      </div>
    </article>
  );
};

export default SpecimenListItemSkeleton;
